import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { AppState } from 'src/app/store/app.state';
import { Endpoints } from "../../shared/config/endpoints";

@Injectable({
  providedIn: 'root'
})
export class ReportRegistryService {
  private server_uri: string = `${this.endpoints.salesClientServiceUrl}/report-registry`;
  private org_id: Number;
  private user_id: Number;

  private all_charts: Map<string, string> = new Map();
  private selected_charts: Map<string, string> = new Map();
  private charts_to_display: Map<string, string> = new Map();
  private user_record: any = {};

  is_loaded: any = new BehaviorSubject<any>(false);

  constructor(
    private endpoints: Endpoints,
    private http: HttpClient,
    private store: Store<AppState>,
  ) {
    this.store.select('userInfo').subscribe(info => {
      this.org_id = info.organization.id;
      this.user_id = info.user.id;
      this.createUserReportSelection();
    });
  }

  addReport(name: string) {
    this.selected_charts.set(name, name);
    this.charts_to_display.set(name, name);
    if (this.selected_charts.size) {
      this.charts_to_display = this.selected_charts;
    }
    this.updateUserReportSelections();
  }

  checkIfReportIsSelected(name: string) {
    return this.selected_charts.has(name);
  }

  checkIfReportIsSelectedForDisplay(name: string) {
    return this.charts_to_display.has(name);
  }

  clearReports() {
    this.selected_charts.clear();
    this.charts_to_display.clear();
  }

  registerReport(name) {
    this.all_charts.set(name, name);
    if (!this.charts_to_display.size) {
      this.charts_to_display = this.all_charts;
    }
  }

  removeReport(name) {
    this.selected_charts.delete(name);
    this.charts_to_display.delete(name);
    if (!this.charts_to_display.size) {
      this.charts_to_display = this.all_charts;
    }
    this.updateUserReportSelections();
  }

  /** */
  fetchUserReportSelections() {
    this.http.get(`${this.server_uri}/filter?userId=${this.user_id}`).subscribe((response: any) => {
      const { payload, success, } = response;
      if (success) {
        this.selected_charts = this.convertObjectToMap(payload[0].selectedCharts);
        this.user_record = payload[0];

        if (!this.selected_charts.size) {
          this.charts_to_display = this.all_charts;
        } else {
          this.charts_to_display = this.selected_charts;
        }

        this.is_loaded.next(true);
      }
    });
  }

  fetchUserReportSelection() {
    return this.http.get(`${this.server_uri}/filter?userId=${this.user_id}`)
  }

  createUserReportSelection() {
    const data = {
      orgId: this.org_id,
      userId: this.user_id,
      selectedCharts: this.setDefaultReports,
    };
    this.http.post(`${this.server_uri}`, data).subscribe(response => {
      this.fetchUserReportSelections();
    })
  }

  get setDefaultReports() {
    let defaults = ['totalsubscriptions', 'totalinvoicesandoverdues', 'marginreport', 'dealswonlost'];
    defaults.forEach(name => {
      this.selected_charts.set(name, name);
      this.charts_to_display.set(name, name);
    });
    let objData = {
      totalsubscriptions: 'totalsubscriptions',
      totalinvoicesandoverdues: 'totalinvoicesandoverdues',
      marginreport: 'marginreport',
      dealswonlost: 'dealswonlost'
    }
    return objData;
    // this.updateUserReportSelections(objData);
  }

  updateUserReportSelections() {
    const data = {
      ...this.user_record,
      selectedCharts: this.convertMapToObject(this.selected_charts),
    }
    this.http.put(`${this.server_uri}`, data).subscribe(response => {
      this.is_loaded.next(true);
    });
  }

  convertObjectToMap(obj) {
    const result = new Map();
    if (!obj) return result;

    Object.keys(obj).forEach(key => {
      result.set(key, key);
    });

    return result;
  }

  convertMapToObject(map: Map<string, string>) {
    let result = {};
    if (!map) {
      return result;
    }

    const keys = map.keys();
    while (1) {
      const { done, value } = keys.next();
      if (done) break;

      result[value] = value;
    }

    return result;
  }
}
